module.exports = __webpack_public_path__ + "static/media/confirmPaymentSuccess.cf437fa1.png";